export default __webpack_public_path__ + "static/media/watermark logo-01.1d69b9df.svg";